var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconSocialTwitterWhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "15px",
    height: "13px",
    viewBox: "0 0 15 13",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 6") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "footer",
    transform: "translate(-954.000000, -38.000000)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "twittericon",
    transform: "translate(954.000000, 38.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,11.0358612 C1.69307363,11.0806769 3.11997129,10.7731915 4.45328197,9.75114504 C3.11632505,9.52084224 2.17437812,8.8946676 1.65782658,7.562646 L2.67391385,7.562646 C1.45849846,6.86924784 0.638093077,5.95924056 0.582183969,4.44173184 L1.89361717,4.80150216 C0.589476462,3.51803088 0.243083077,2.19845808 0.997856031,0.58633848 C2.69943757,2.55698352 4.76564372,3.65496768 7.33381643,3.84916896 C7.33381643,3.454542 7.29249231,3.10224096 7.33381643,2.76612336 C7.66927108,0.4170348 10.2495979,-0.7967232 12.1432151,0.5788692 C12.7229682,0.99963864 13.1556561,0.90751752 13.6855772,0.71207136 C13.9639074,0.60874632 14.2325142,0.4792788 14.5059826,0.3610152 L14.6275242,0.47180952 L13.6333144,1.89968688 L14.8596685,1.618344 L14.9471784,1.70922024 C14.61537,2.0665008 14.2604687,2.4026184 13.9614765,2.78728632 C13.7803796,3.02132376 13.5846978,3.3238296 13.5713282,3.6039276 C13.3561997,7.99959888 10.5838372,11.421774 6.50368772,12.240905 C4.25395385,12.697776 2.14034649,12.3081286 0,11.0358612 Z",
    id: "Path"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSocialTwitterWhite);
export default __webpack_public_path__ + "static/media/icon-social-twitter-white.83a7c793.svg";
export { ForwardRef as ReactComponent };